import React from "react";

const PenaltyTwo = () => {
  return (
    <svg
      width="14"
      viewBox="0 0 170 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M84.9618 77.2456C82.5098 77.2456 80.1094 76.5533 78.039 75.2399L6.87353 29.9531C0.714199 26.33 -1.33676 18.3987 2.28637 12.2394C5.90951 6.08003 13.8408 4.02908 20.0001 7.65222C20.2654 7.8075 20.5306 7.97571 20.783 8.1504L84.961 48.9738L149.204 8.0857C155.24 4.24259 163.249 6.02829 167.092 12.0647C170.935 18.1011 169.15 26.11 163.113 29.9531L91.9477 75.2399C89.8595 76.5597 87.4333 77.2585 84.9618 77.2456Z"
        fill="#4A2617"
      />
      <path
        d="M84.9618 71.8C82.5098 71.8 80.1094 71.1077 78.039 69.7943L6.87353 24.5076C0.714199 20.8844 -1.33676 12.9531 2.28637 6.79381C5.90951 0.634478 13.8408 -1.41647 20.0001 2.20666C20.2654 2.36194 20.5306 2.53016 20.783 2.70484L84.961 43.5282L149.204 2.64014C155.24 -1.20297 163.249 0.582729 167.092 6.61913C170.935 12.6555 169.15 20.6644 163.113 24.5076L91.9477 69.7943C89.8595 71.1142 87.4333 71.8129 84.9618 71.8Z"
        fill="#E16A3C"
      />
      <path
        d="M167.06 6.65137C165.682 4.50983 163.703 2.82119 161.367 1.79895C164.026 7.64773 161.988 14.5632 156.579 18.0376L77.9741 69.7942C82.2184 72.4986 87.6393 72.4986 91.8836 69.7942L163.049 24.5074C169.086 20.6837 170.884 12.6934 167.06 6.65137Z"
        fill="black"
        fillOpacity="0.24"
      />
      <path
        d="M84.9618 127.431C82.5098 127.431 80.1094 126.739 78.039 125.426L6.87353 80.1388C0.714199 76.5156 -1.33676 68.5844 2.28637 62.425C5.90951 56.2657 13.8408 54.2148 20.0001 57.8379C20.2654 57.9932 20.5306 58.1614 20.783 58.3361L84.961 99.1594L149.204 58.2714C155.24 54.4283 163.249 56.214 167.092 62.2504C170.935 68.2868 169.15 76.2957 163.113 80.1388L91.9477 125.426C89.8595 126.745 87.4333 127.444 84.9618 127.431Z"
        fill="#4A2617"
      />
      <path
        d="M84.9618 121.986C82.5098 121.986 80.1094 121.293 78.039 119.98L6.87353 74.6932C0.714199 71.0701 -1.33676 63.1388 2.28637 56.9795C5.90951 50.8201 13.8408 48.7692 20.0001 52.3923C20.2654 52.5476 20.5306 52.7158 20.783 52.8905L84.961 93.7139L149.204 52.8258C155.24 48.9827 163.249 50.7684 167.092 56.8048C170.935 62.8412 169.15 70.8501 163.113 74.6932L91.9477 119.98C89.8595 121.3 87.4333 121.999 84.9618 121.986Z"
        fill="#E16A3C"
      />
      <path
        d="M167.06 56.837C165.682 54.6955 163.703 53.0069 161.367 51.9846C164.026 57.8334 161.988 64.7489 156.579 68.2232L77.9741 119.98C82.2184 122.684 87.6393 122.684 91.8836 119.98L163.049 74.6931C169.086 70.8694 170.884 62.8791 167.06 56.837Z"
        fill="black"
        fillOpacity="0.24"
      />
    </svg>
  );
};

export default PenaltyTwo;
